import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface LogoProps {
  size?: "small" | "medium" | "large";
}

export default function Logo({ size = "medium" }: LogoProps) {
  const navigate = useNavigate();

  const sizeConfig = {
    small: {
      width: "120px",
      fontSize: "0.9rem",
      padding: "4px 8px",
      iconSize: "16px",
    },
    medium: {
      width: "150px",
      fontSize: "1rem",
      padding: "8px 10px",
      iconSize: "20px",
    },
    large: {
      width: "200px",
      fontSize: "1.3rem",
      padding: "8px 15px",
      iconSize: "28px",
    },
  };

  const config = sizeConfig[size];

  return (
    <Box
      onClick={() => navigate("/dashboard")}
      sx={{
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        width: config.width,
        padding: config.padding,
        background: "linear-gradient(135deg, #fff 0%,#fff 100%)",
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(11, 110, 165, 0.3)",
        transition: "all 0.3s ease",
        position: "relative",
        overflow: "hidden",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 6px 16px rgba(11, 110, 165, 0.4)",
        },
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: "-100%",
          width: "100%",
          height: "100%",
          background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)",
          transition: "left 0.5s",
        },
        "&:hover::before": {
          left: "100%",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: config.iconSize,
          height: config.iconSize,
          borderRadius: "4px",
          backgroundColor: "rgba(255, 255, 255, 0.2)",
          fontSize: config.iconSize,
        }}
      >
        📊
      </Box>
      <Typography
        variant="h6"
        sx={{
          fontWeight: "bold",
          fontSize: config.fontSize,
          color: "#000000",
          textShadow: "0 2px 4px rgba(0,0,0,0.2)",
          letterSpacing: "0.5px",
          lineHeight: 1,
        }}
      >
        Ensisheim Stats
      </Typography>
    </Box>
  );
}
